import { RouteHandler } from 'wee-routes';
import $fetch from 'wee-fetch';
import $ from 'wee-dom';
import { $env } from 'core/core';

function runDynamicHeader(data) {
    if (data.loggedIn === true) {
        $('.login').text(`Hello, ${data.userFirstName}`);
        $('.login-nav__link').eq(0).text('Logout')
            .attr('href', 'https://abeka.com/ABekaOnline/CustomerService/CustomerLogout.aspx');

        if (data.numItemsInCart > 0) {
            $('.cart').addClass('-items')
                .find('.item-count')
                .text(`${data.numItemsInCart}`);
        }
    }
}

export default new RouteHandler({
    init() {
        const defaultData = {
            loggedIn: false,
            userFirstName: null,
            numItemsInCart: 0,
        };

        if ($env() === 'local') {
            runDynamicHeader(defaultData);
        } else {
            $fetch.get('https://www.abeka.com/WSAPI/GetBlogHeader.ashx')
                .then(({ data }) => {
                    runDynamicHeader(data);
                })
                .catch(error => console.log(error));
        }
    },
});
